import { Component, inject, OnDestroy, OnInit } from "@angular/core";

import { AccordionModule } from "primeng/accordion";
import { TagModule } from "primeng/tag";

import { VersionsService } from "@features/about/services/versions.service";
import { SubPageComponent } from "@shared/components";
import { GlobalService } from "@shared/services";
import { Subscription } from "rxjs";

@Component({
  selector: "app-versions",
  standalone: true,
  imports: [SubPageComponent, AccordionModule, TagModule],
  templateUrl: "./versions.component.html",
  styleUrls: ["./versions.component.scss"],
})
export class VersionsComponent implements OnInit, OnDestroy {
  versionsService = inject(VersionsService);
  globalService = inject(GlobalService);
  versionsSubscription: Subscription | null = null;

  versions: any;

  ngOnInit() {
    this.versionsSubscription = this.versionsService.getVersions().subscribe((versions) => {
      this.versions = versions;
    });
  }

  ngOnDestroy() {
    if (this.versionsSubscription) {
      this.versionsSubscription.unsubscribe();
    }
  }

  getContainerHeight(): string {
    return `calc(100vh - ${this.globalService.navbarHeight()}px)`;
  }
}
